import * as React from 'react';

const { createContext, useContext, useState } = React

const ResultContext = createContext()
const baseUrl = 'https://google-search3.p.rapidapi.com/api/v1';

export const ResultContextProvider = ({ children }) => {
    const [results,setResults]=useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [searchTerm, setSearchTerm] = useState('Elon Mask')
    const getResults = async (type) => {
        setIsLoading(true)
        const response = await fetch(`${baseUrl}${type}`, {
          method: 'GET',
          headers: {
            'x-user-agent': 'desktop',
            'x-rapidapi-host': 'google-search3.p.rapidapi.com',
            'x-rapidapi-key':
              '194f789e10msh584dfead32dcf38p1d0a30jsnc411737108ce'
          }
        });
        const data = await response.json()
        if (type.includes('/news')) {
            setResults(data.entries);
        } else if (type.includes('/images')) {
            setResults(data.image_results)
        } else {
            setResults(data.results)
        }
        
        setIsLoading(false)
    }
    return (
        <ResultContext.Provider value={{getResults,results,searchTerm,setSearchTerm,isLoading}}>
            {children}
        </ResultContext.Provider>
    )
}

export const useResultContext=()=>useContext(ResultContext)